import { Box, Image } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { COMMON_WEB_PATH } from '../../../constant';
import useCheckLogin from '../../../hook/useCheckLogin';
import { openLanguagePop } from '../../../redux/action/member/memberAction';

const LngButton = () => {
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const dispatch = useDispatch();

  const iconSize = useMemo(() => {
    return {
      base: '45px',
      md: '55px',
      xl: '65px'
    };
  }, []);

  const iconHeightSize = useMemo(() => {
    return {
      base: '40px',
      md: '50px',
      xl: '60px'
    };
  }, []);

  return (
    <Box
      onClick={() => {
        dispatch(openLanguagePop());
      }}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Image
        src={`${COMMON_WEB_PATH}/blue-layout/header/lng_icon.png`}
        height={iconHeightSize}
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default LngButton;
